import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { JobsPage, ModalAddJobsPage, ModalAddVacationPage } from './jobs';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  declarations: [
    JobsPage,
    ModalAddJobsPage,
    ModalAddVacationPage,
  ],
  imports: [
    IonicPageModule.forChild(JobsPage),
    CalendarModule,
    NgxPaginationModule,
  ],

  entryComponents: [
    ModalAddJobsPage,
    ModalAddVacationPage,
  ],
  providers: [
    RestProvider,
  ]
})
export class JobsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/jobs/jobs.module.ts